
import { useState } from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

const chefs = [
  {
    name: "Wanda Maximoff",
    role: "Caterers Manager",
    img: "https://picsum.photos/400/550?random=501",
    desc: "Expert in luxury catering & event dining.",
  },
  {
    name: "Alex Prior",
    role: "Head Chef",
    img: "https://picsum.photos/400/550?random=502",
    desc: "Master of continental & Mediterranean cuisine.",
  },
  {
    name: "Emily Stone",
    role: "Pastry Expert",
    img: "https://picsum.photos/400/550?random=503",
    desc: "Baking happiness for every celebration.",
  },
  {
    name: "Mark Holmes",
    role: "Sous Chef",
    img: "https://picsum.photos/400/550?random=504",
    desc: "Ensuring perfection behind every dish.",
  },
];

export default function TeamCard3() {
  const [active, setActive] = useState(0);

  return (<>
    <div className="tc3-wrap">
      <div className="tc3-grid">
        {chefs.map((chef, i) => (
          <div
            key={i}
            className={`tc3-card ${active === i ? "tc3-active" : ""}`}
            onMouseEnter={() => setActive(i)}
          >
            <div className="tc3-img">
              <img src={chef.img} alt={chef.name} />
              <span className="tc3-animated-border">
                <h2 className="tc3-nameAuthor">{chefs[active].name}</h2>
        <p className="tc3-nameAuthor">{chefs[active].role}</p>
         {/* Hover Social Icons */}
                      <div className="icon-bar-tc3">
                        <a href="#">  <FaFacebookF />
                                    </a>
                        <a href="#"><FaTwitter />
                                   </a>
                        <a href="#"> <FaInstagram />
                                   </a>
                        <a href="#"> <FaLinkedinIn />
                                    </a>
                      </div>
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="tc3-detail">
        <h2>{chefs[active].name}</h2>
        <p className="tc3-role">{chefs[active].role}</p>
        <p className="tc3-desc">{chefs[active].desc}</p>
        <div className="icon-bar-tc3">
                        <a href="#">  <FaFacebookF />
                                    </a>
                        <a href="#"><FaTwitter />
                                   </a>
                        <a href="#"> <FaInstagram />
                                   </a>
                        <a href="#"> <FaLinkedinIn />
                                    </a>
                      </div>
      </div>
    </div>
    <style>{`.tc3-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding: 60px 20px;
}
.tc3-nameAuthor{color:#ffffff;}
.tc3-grid {  width: 320px;
  display: grid;
  grid-template-columns: repeat(2, 160px);
  gap: 20px;
}

.tc3-card {
  cursor: pointer;
  position: relative;
}

.tc3-img {
  position: relative;
  width: 160px;
  height: 200px;
  overflow: hidden;
  border-radius: 6px;
}

.tc3-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.tc3-img:hover img {
  opacity:0.7;
}

/* 🔥 Animated Border Frame */
.tc3-animated-border {
  position: absolute;
  inset: 0;top:8px;left:8px;right:8px;bottom:8px;
  border: 3px solid rgba(144, 202, 249,1);
  border-radius: 8px;padding:2px;
  box-sizing: border-box;
  opacity: 0;
  transform: scale(1.1);
  transition: 0.4s ease-in-out;
}

.tc3-card.tc3-active .tc3-animated-border {
  opacity: 1;
  transform: scale(1);
  animation: frameDraw 0.6s linear forwards;
}

/* 🖌 Corner Draw Effect */
@keyframes frameDraw {
  0% {
    clip-path: inset(50% 50% 50% 50%);
  }
  100% {
    clip-path: inset(0 0 0 0);
  }
}

.tc3-detail {position:relative;
  width: 320px;
  text-align: left;
}

.tc3-detail h2 {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 6px;
}
.tc3-detail .tc3-role {
  font-weight: 500;
  color: rgba(144, 202, 249,1);
  margin-bottom: 12px;
}
.tc3-detail .tc3-desc {
  font-size: 14px;
  line-height: 1.5;
}
  
/* Social icons sliding up */
.icon-bar-tc3 {
  position: absolute;
  bottom: -60px;
  width: 90%;
  background: rgba(144, 202, 249,0.21);padding:5px;border-radius:5px;
  display: flex;
  justify-content: center;
  gap:5px;
  transition: 0.35s ease;
}

.icon-bar-tc3 a {
  width: 32px;
  height: 32px;
  background: #ffffff;
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 14px;
  transition: 0.25s;
}

.icon-bar-tc3 a:hover {
  background: rgba(144, 202, 249,1);;
}

/* Slide-up effect on hover */
.tc3-card:hover .icon-bar-tc3 {
  bottom: 6px;
}
/* responsive */
@media (max-width: 768px) {.tc3-wrap {
  display: flex;

  justify-content: space-between;flex-wrap:wrap;
  gap: 40px;
  padding: 60px 0px;
}}
`}</style>
  </>);
}
